import Avatar from 'react-avatar';
import { RequestLoading } from 'views/components/CommonPages';
import logo from '../../assets/img/saw-logo.png';
import plus from '../../assets/img/plus.svg';
// import clearCircle from '../../assets/img/clear-circle.png';
// import questionCircle from '../../assets/img/help-circle.png';
import { getPublicRegistrarAvatarURL } from 'utils/handler';
import Stepcard from './Stepcard';
import { useState } from 'react';

const stepCardData = [
    {
        stepCount: "step 1",
        stepHeading: "Fill out the form",
        stepDescription: "Confirm your chosen domain and provide your details: name, contact information, and desired budget."
    },
    {
        stepCount: "step 2",
        stepHeading: "We’ll contact you",
        stepDescription: "Our broker will discuss the details and answer any questions."
    },
    {
        stepCount: "step 3",
        stepHeading: "The domain is yours",
        stepDescription: "We’ll quickly negotiate favorable terms, acquire the domain, and transfer it to you."
    }
]

interface RegistrarVariant1Props {
    registrarDetails: any
    domainName: string
    learnMore: () => void
}

export const RegistrarVariant1: React.FC<RegistrarVariant1Props> = ({ registrarDetails, domainName, learnMore }): JSX.Element => {
    const [popup, setPopup] = useState(false)
    return (
        <div className='registrar-variant-1'>


            {/* {popup && <div className="popup-password-window" >
                <div className={"popup-content card"}>
                    <div className="card-body popup-body">
                    <img src={clearCircle} alt="Img" className="fa-regular fa-circle-xmark" onClick={() => { setPopup(false)}}></img>
                        <div className="card-head">
                            You get a dedicated domain broker.
                        </div>
                        <div className="card-desc card-desc-mb">
                            When you choose this service, a dedicated broker will assist you in creating a strategy and setting a budget to help acquire your desired domain.
                        </div>

                        <div className="card-head">
                            The domain broker negotiates on your behalf.
                        </div>
                        <div className="card-desc card-desc-mb">
                            The broker communicates directly with the domain owner, working to secure the lowest possible price. (Rest assured, your identity stays confidential.)
                        </div>

                        <div className="card-head">
                            The domain is safely transferred to your account.
                        </div>
                        <div className="card-desc">
                            Once the owner agrees to the sale, you pay the negotiated price plus a 20% commission. The domain is then securely transferred to your account, with Saw.com managing every step of the process to ensure a seamless transaction.                        </div>
                    </div>
                </div>
            </div>} */}



            <div className="saw_registrar_logo_start_screen">
                {registrarDetails?.image || registrarDetails?.name ? (
                    <Avatar className="edit-user-image " textSizeRatio={3} src={getPublicRegistrarAvatarURL(registrarDetails?.UID, registrarDetails?.image)} name={registrarDetails.name} />
                ) : (
                    <div className=" d-flex align-items-center text-right ">
                        <RequestLoading color="#031B4E" height={20} width={3} />
                    </div>
                )}
                <img src={plus} className="fa-plus-cus mx-3" alt="Img"></img>
                <div className="">
                    <img src={logo} className="saw-logo" alt="Img"></img>
                </div>
            </div>

            <div className="sub-title-wrapper my-4">
                <div className="sub-title">We've teamed up with the experts at Saw.com to help you buy that domain! </div>
            </div>

            <div className="domain-wrapper">
                <div className="acquire">
                    Speak with an agent to acquire
                    {/* <img src={questionCircle} className="acquire-icon" alt="Img" onClick={() => { setPopup(true) }}></img> */}
                </div>

                <div className="domain-name">
                    <p className='domain-name-cap'>{domainName}</p>
                    
                </div>

                <button className="get-started" onClick={() => learnMore()}>
                    Get Started
                </button>

                <div className="how-it-works">
                    HOW IT WORKS
                </div>

                <div className="step-cards">
                    {stepCardData.map((stepCarddata) => <Stepcard {...stepCarddata} />)}
                </div>
            </div>
        </div>
    );
};

export default RegistrarVariant1;
